import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ApParagraphSkeletonComponent, ApSkeletonComponent } from '@ap/skeleton';

@Component({
    selector: 'conversational-chat-skeleton',
    templateUrl: 'conversational-chat-skeleton.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ApParagraphSkeletonComponent, ApSkeletonComponent]
})
export class ConversationalChatSkeletonComponent {}
